import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Form, FadeIn, Section, Overlay, FormJobber } from '../../common';

const FormFull = (props) => {
  const { page, sanity } = props;
  const { colors, form } = sanity;

  return (
    <Section idName="form-full" padding="none">
      <div className="relative flex flex-col place-content-center place-items-center">
        <div className="absolute inset-0">
          <GatsbyImage
            image={form?.bgImg?.asset?.gatsbyImageData}
            alt={form?.bgImg?.alt}
            className="h-full w-full object-cover"
            loading="eager"
          />
          <Overlay
            isGradient={true}
            bgColor={colors?.neutral?.default}
            bgColorHover={colors?.neutral?.dark}
            bgColorStart={colors?.neutral?.dark}
            bgColorMid={colors?.neutral?.default}
            bgColorEnd={colors?.neutral?.light}
          />
        </div>
        <FadeIn classes="z-10 px-3 lg:px-0 py-24">
          <Form page={page} sanity={sanity} formName="form-footer" />
        </FadeIn>
      </div>
    </Section>
  );
};

export { FormFull };
